import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, inject, onBeforeMount } from "vue";
import Storage from "@/core/config/Storage";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const { locale } = useI18n();
const store = useStore();
const setting = ref() as any;
// const style = ref("style-1");
const style = ref(route.path.includes("/s2") ? "style-3" : "style-1");

onBeforeMount(async () => {
  if (!window.location.pathname.includes("/play")) {
    Storage.setStyle(
      window.location.pathname.includes("/s") ? "style-3" : "style-1"
    );
  }

  document.body.classList.add(Storage.getStyle());

  let settingValue = store.getters["siteSetting/getList"].data;
  while (!settingValue) {
    await new Promise((resolve) => setTimeout(resolve, 100));
    settingValue = store.getters["siteSetting/getList"].data;
  }
  setting.value = settingValue;

  const lang = Storage.getLang();
  locale.value = lang === "en" || lang === "th" ? lang : "en";
  Storage.setLang(locale.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    justify: "center",
    style: {"height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(`body-view position-relative`),
        style: _normalizeStyle({
        boxShadow: `var(--el-box-shadow-dark)`,
      })
      }, [
        _createVNode(_component_router_view)
      ], 4)
    ]),
    _: 1
  }))
}
}

})